export const nameInitials = (name?: string): string => {
  if (!name) return '';

  return name
    .split(' ')
    .filter((n) => n !== '')
    .map((splitName) => splitName.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');
};

export const getTitleCase = (name: string) =>
  name.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
